const usZipcode = (value) => {
  const pattern = /^\d{5}(-\d{4})?$/;

  if (!(pattern.test(value))) {
    return ['checkout.error.formFields.postalCode', '00000 or 00000-0000'];
  }
};

export default usZipcode;
